import InvestorGoalError from './InvestorGoalError';
class AccountValueMustNotBeNegative extends InvestorGoalError {
    constructor(options) {
        super('The account value must be more than zero', options);
    }
}
export default AccountValueMustNotBeNegative;
